<main>
  <div class="container pt-5">

    <div class="row mb-4">
      <div class="col general-title">
        <h2>Solicitações</h2>
      </div>
    </div>

    <div class="table-responsive">
      <table class="table table-bordered text-center">
        <thead class="thead-light">
          <tr>
            <th>Data Solicitação</th>
            <th>Categoria</th>
            <th>Coberturas</th>
            <th>Capital Segurado(Morte/Invalidez)</th>
            <th>Prêmio</th>
            <th>Proposta</th>
            <th>Status</th>
            <th>Data Conclusão</th>
          </tr>
        </thead>
        <tbody>
          @for (item of lista; track item) {
            <tr>
              <td>{{item.TIM_SOLICITACAO| date:"dd/MM/yyyy HH:mm:ss"}}</td>
              <td>{{item.DCR_SOLIC_CATEGORIA}}</td>
              <td>{{item.DCR_COBERTURA}}</td>
              <td>{{item.VLR_COBERTURA_MORTE| currency:'R$'}} / {{item.VLR_COBERTURA_INVALIDEZ| currency:'R$'}}</td>
              <td>{{(item.VLR_PREMIO_MORTE + item.VLR_PREMIO_INVALIDEZ)| currency:'R$'}}</td>
              <td>
                <button class="btn btn-default text-danger" style="font-size: 20px; padding: 0;" (click)="baixarProposta(item.COD_SOLIC, item)" [disabled]="item?.loading">
                  <i class="fas fa-file-pdf"></i>
                </button>
              </td>
              <td>{{item.DCR_SOLIC_STATUS}}</td>
              <td>{{item.TIM_FIM_SOLICITACAO| date:"dd/MM/yyyy HH:mm:ss"}}</td>
            </tr>
          }
        </tbody>
      </table>
    </div>

  </div>
</main>

